import type { Definition } from './definition';

export type OrganizationNode = {
  id: string;
  number: string;
  folders?: Record<string, OrganizationNode>;
};
// 組織
// TIPS: 確認コマンド例: 'gcloud projects list --format="table(projectId, projectNumber)" | grep production'
const PlaidCoJp = {
  id: 'plaid.co.jp',
  number: '255758916152',
  folders: {
    righttouch: {
      id: 'righttouch',
      number: '378181954152',
      folders: {
        'righttouch-eva': {
          id: 'righttouch-eva',
          number: '342101291509',
          folders: {
            'evaluation-rt-systems': {
              id: 'evaluation-rt-systems',
              number: '282057777327',
            },
            'evaluation-rt-knowledge': {
              id: 'evaluation-rt-knowledge',
              number: '164393146105',
            },
            'evaluation-rt-debeso': {
              id: 'evaluation-rt-debeso',
              number: '277506514704',
            },
            'evaluation-rt-troppus': {
              id: 'evaluation-rt-troppus',
              number: '941568787903',
            },
          },
        },
        'righttouch-eva-pii': {
          id: 'righttouch-eva-pii',
          number: '372147494832',
          folders: {
            'evaluation-rt-systems-pii': {
              id: 'evaluation-rt-systems-pii',
              number: '284891476675',
            },
          },
        },
        'righttouch-prod': {
          id: 'righttouch-prod',
          number: '1064786150788',
          folders: {
            'production-rt-systems': {
              id: 'production-rt-systems',
              number: '402791595004',
            },
            'production-rt-knowledge': {
              id: 'production-rt-knowledge',
              number: '473576939563',
            },
            'production-rt-debeso': {
              id: 'production-rt-debeso',
              number: '475156578770',
            },
            'production-rt-troppus': {
              id: 'production-rt-troppus',
              number: '350934821882',
            },
          },
        },
        'righttouch-prod-pii': {
          id: 'righttouch-prod-pii',
          number: '907109369205',
          folders: {
            'production-rt-systems-pii': {
              id: 'production-rt-systems-pii',
              number: '768973697261',
            },
          },
        },
      },
    },
  },
} as const satisfies OrganizationNode;

export const Const = () =>
  ({
    Domain: 'dev-righttouch.com',
    QantDomain: 'qant.jp',
    PrivateDomain: 'qant.local',
    // スマートFAQ 公開サイトの本番ワイルドカード基底ドメイン。
    // テナントごとに `<sub>.qant.support` で配信する。
    // 管理画面 (QantDomain) とは別 registrable domain にすることで、テナントの `<script>` から
    // 管理画面の cookie に触れる経路を断つ (apps/smart-faq/docs/product-brief.md §8.1)。
    QantSupportDomain: 'qant.support',
    Git: {
      Owner: 'righttouch',
      Name: 'systems',
    },
    Gcloud: {
      Region: 'asia-northeast1',
      GpuRegion: 'asia-southeast1',
      ContainerRepository: {
        Id: 'rt',
      },
      Organization: PlaidCoJp,
      SecondaryBackupRegion: 'asia-northeast2',
    },
    Aws: {
      Region: 'ap-northeast-1',
    },
    MongoAtlas: {
      OrganizationId: '67f60f7a25cc6777cbd1c79d',
      IdpId: '68a54d25515f8338700d6c7a',
    },
    BasicAuthCredential: 'YWRtaW5AYWRtaW4uY29tOjdQeUpaLW10dUJOaGNFV0gqQTQ',
    Terraform: {
      statePrefix: (system: Definition.System, stack: string) => {
        return `${system}/${stack}`;
      },
    },
  }) as const;
